import { ACCOUNTS_PAYROLL_FULL_PATH } from "../paths";

export const PROOF_OF_EARNINGS_PATH = "proofOfEarnings";
export const ACCOUNTS_PAYROLL_PROOF_OF_EARNINGS_FULL_PATH = `${ACCOUNTS_PAYROLL_FULL_PATH}/${PROOF_OF_EARNINGS_PATH}`;
